import { Query, QueryCondition } from "../../api/apiTypes";

export const GetFilterValues = <T>(
            member: string, // TODO: Could use keyof(T) here but it will only check shallow properties not nested ones that use the "dot" syntax
            condition: QueryCondition,
            query: Query<T>
        ): any =>
            query &&
            query.Filters &&
            query.Filters.find(item => item.Member === member && item.Condition === condition) &&
            query.Filters.find(item => item.Member === member && item.Condition === condition)
                .Values;
